module.exports = __webpack_public_path__ + "static/img/rpacj4.3e0bbbfb.png";